module.exports = __webpack_public_path__ + "static/media/ocr.97e47fc3.svg";